import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { CoreSettingsService } from '../settings/core-settings.service'

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  constructor(private settings: CoreSettingsService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const origin = document.location.origin

    const uri = new URL(request.url)

    if (request.url.startsWith(this.settings.settings.urls.prodspageServiceAPI)) {
      return next.handle(request)
    }

    request = request.clone({
      withCredentials: true,
      setHeaders: {
        // use in bmstv (old project)
        // 'BMTVS-Domain-Origin': origin
      }
    })

    return next.handle(request)
  }
}
